import { type SelectOption } from '../../../../../../components';
import { CONDITION_TYPE } from './constant';

export const conditionCheckOptions: SelectOption[] = [
  {
    value: 'MEET',
    label: 'Meet',
  },
  {
    value: 'NOT_MEET',
    label: 'Not Meet',
  },
];

export const conditionCheckTypeOptions: SelectOption[] = [
  {
    value: CONDITION_TYPE.GENERAL_REQUIREMENT,
    label: 'General Requirement',
  },
  {
    value: CONDITION_TYPE.ENGLISH_REQUIREMENT,
    label: 'English Requirement',
  },
  {
    value: CONDITION_TYPE.OTHER_TEST_REQUIREMENT,
    label: 'Other Test Requirement',
  },
  {
    value: CONDITION_TYPE.OTHERS_REQUIREMENT,
    label: 'Other Test Requirement',
  },

  {
    value: CONDITION_TYPE.ADDITIONAL_REQUIREMENT,
    label: 'Additional Requirement',
  },
];
